import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { StoreService } from '@common/services/store.service';
import { CommonDialogsService } from '@common/dialogs/common-dialogs.service';

import { CredentialsService } from './credentials.service';
import { AccessRefreshTokenResponse } from '@common/models/access-refresh-token-model';
import { UserInfoModel } from '@common/models/response-model';
import {Observable, of, switchMap} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

export class Login {
  readonly translationPath = 'login.';

  constructor(
    protected router: Router,
    protected store: StoreService,
    protected commonDialog: CommonDialogsService,
    protected credentialsService: CredentialsService,
    protected translate: TranslateService
  ) { }

  private onVerifiedLogin(userInfo: UserInfoModel) {
    this.store.updateUserInfo(userInfo);
    this.router.navigateByUrl('desktop');
  }

  protected onTokenResponse( user: string, tokenResponse: AccessRefreshTokenResponse ) {
    if ( tokenResponse.access && tokenResponse.refresh ) {
      this.commonDialog
        .openTranslatedMessageDialog$(this.translationPath + 'greeting', { name: user })
        .subscribe({
          next: () => this.onCorrectLogin(user, tokenResponse),
        });
    } else {
      this.onInvalidLogin(tokenResponse).subscribe({
        error: (dialogError) => console.error('Login invalid dialog failed', dialogError),
      });
    }
  }

  private onCorrectLogin( user: string, tokenResponse: AccessRefreshTokenResponse ) {
    this.store.updateUserJwtTokenAfterLoginRegistration( user, tokenResponse.access,  tokenResponse.refresh );
    this.credentialsService.getUserInfo$().subscribe({
      next: (userInfo: UserInfoModel) => {
        if (!userInfo.remaining || userInfo.remaining.subscription_days > 0) {
          this.onVerifiedLogin(userInfo);
        } else {
          this.onExpiredLogin();
        }
      },
      error: (httpError) => {
        this.onInvalidLogin(httpError).subscribe({
          error: (dialogError) => console.error('Login user info error dialog failed', dialogError),
        });
      },
    });
  }

  private onExpiredLogin() {
    this.store.clearStoredUser();
    console.warn( 'Expired subscription.' );
    this.commonDialog.openTranslatedMessageDialog$('common.messages.3xp1r3dSubscr1pt10n');
  }

  protected onInvalidLogin(responseData: unknown): Observable<any> {
    let message: string;

    if (responseData instanceof HttpErrorResponse) {
      const body = responseData.error;
      if (typeof body === 'string') {
        message = body;
      } else if (body && typeof body === 'object') {
        const errorBody = body as Record<string, unknown>;
        const errorsField = errorBody['errors'];
        message =
          (typeof errorsField === 'string' ? errorsField : null) ||
          (Array.isArray(errorsField) ? errorsField.join(', ') : null) ||
          (typeof errorBody['message'] === 'string' ? (errorBody['message'] as string) : null) ||
          (typeof errorBody['detail'] === 'string' ? (errorBody['detail'] as string) : null) ||
          responseData.message ||
          responseData.statusText ||
          'Login inválido';
      } else {
        message =
          responseData.message ||
          responseData.statusText ||
          'Login inválido';
      }
      if (responseData.status) {
        console.warn('Login HTTP error', responseData.status, message);
      }
    } else {
      const payload = responseData as Record<string, unknown>;
      const nestedError = payload['error'] as { errors?: string } | undefined;
      message =
        nestedError?.errors ||
        (typeof payload['message'] === 'string' ? (payload['message'] as string) : null) ||
        (typeof payload['statusText'] === 'string' ? (payload['statusText'] as string) : null) ||
        'Login inválido';

      if (nestedError?.errors && typeof payload['message'] === 'string') {
        console.error(payload['message']);
      }
    }

    this.store.clearStoredUser();

/*
    if ( message.includes('User not found. Please contact the administrator.') ) {
      this.translate.get(this.translationPath + 'kayroxUserNotFound')
        .subscribe({
          next: (response) => message = response,
          error: (err) => console.error(err)
        });
    }

    return this.commonDialog.openMessageDialog$ ( message );
*/
    return of(message).pipe(
      switchMap((messageToShow) => {
        if (messageToShow.includes('User not found. Please contact the administrator.')) {
          return this.translate.get(this.translationPath + 'messages.kayroxUserNotFound');
        }
        return of(messageToShow);
      }),
      switchMap((resolvedMessage) => this.commonDialog.openMessageDialog$(resolvedMessage)),
    );
  }
}
